export default __webpack_public_path__ + "static/media/image7.134ce147.png";